import { getFloatOrDecimalNumber } from '@/shared/utils/formatters';

// Reuirements described under HIP-907
const withIssuesPercentage = 1;

export const checkWithIssues = (worker: any = {}) => {
  let isWithIssues = false;
  if (
    (typeof worker.staleRate === 'number' && getFloatOrDecimalNumber(worker.staleRate) >= withIssuesPercentage)
   || (typeof worker.invalidRate === 'number' && getFloatOrDecimalNumber(worker.invalidRate) >= withIssuesPercentage)
  ) {
    isWithIssues = true;
  }
  return isWithIssues;
}
